

import { isAuthenticated } from "../services/auth";
import { appendALink } from "./alink";

export function renderFooter(container: HTMLElement): void {

    const isUserAuthenticated = isAuthenticated();
    const isLoadedWizward = window.location.pathname.startsWith('/wizard/');
    const isOnline = navigator.onLine;
    
    //const footerLink = ; //`<a href="${onHe}" class="footer-link">Help</a>`;

    const syncIndicator = `<span id="sync-status" class="sync-status ${isOnline ? 'online' : 'offline'}">
      ${isOnline ? '● Online' : '● Offline'}
    </span>`;

    container.innerHTML = `
      <div class="footer-content">
        <div class="footer-left">
          <span id="db-status" class="db-status"></span>
          ${isUserAuthenticated ? syncIndicator : ""}
          ${isOnline && isUserAuthenticated && isLoadedWizward === false ? '<button id="sync-btn" type="button" class="sync-btn">Sync Now</button>' : ''}
          <span id="last-sync" class="last-sync"></span>
        </div>
        <div class="footer-center">
          <span>&copy; ${new Date().getFullYear()} Walk In Bath Co. v${__APP_VERSION__} All rights reserved. </span>
        </div>
        <div class="footer-right">
          ${isUserAuthenticated && isLoadedWizward === false ? '<button id="export-db-btn" type="button" class="export-btn">Export DB</button>' : ''}
          ${ isUserAuthenticated ? '<div id="help-links"></div>' : "" }
        </div>
      </div>
    `;

    if(isUserAuthenticated === true) {
      const footerLinksElement = container.querySelector("#help-links") as HTMLElement;
      if(footerLinksElement) {
        appendALink(footerLinksElement, { href: "/help", text: "Help" });
      }
    }
}

export function updateFooterSyncStatus(isOnline: boolean, lastSyncTime?: Date): void {
  const syncStatus = document.getElementById('sync-status');
  const syncBtn = document.getElementById('sync-btn');
  const lastSync = document.getElementById('last-sync');
  
  if (syncStatus) {
    syncStatus.className = `sync-status ${isOnline ? 'online' : 'offline'}`;
    syncStatus.textContent = isOnline ? '● Online' : '● Offline';
  }
  
  // Show/hide sync button based on online status
  if (syncBtn) {
    syncBtn.style.display = isOnline ? 'inline-block' : 'none';
  } else if (isOnline) {
    // Add sync button if it doesn't exist and we're online
    const footerLeft = document.querySelector('.footer-left');
    if (footerLeft && !document.getElementById('sync-btn')) {
      const btn = document.createElement('button');
      btn.id = 'sync-btn';
      btn.className = 'sync-btn';
      btn.textContent = 'Sync Now';
      footerLeft.insertBefore(btn, lastSync);
    }
  }
  
  // Update last sync time
  if (lastSync && lastSyncTime) {
    const timeAgo = getTimeAgo(lastSyncTime);
    lastSync.textContent = `Last sync: ${timeAgo}`;
  }
}

function getTimeAgo(date: Date): string {
  const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
  
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}
